import { render } from "./Sheet.vue?vue&type=template&id=41bba789&ts=true"
import script from "./Sheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sheet.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/Sheet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41bba789"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41bba789', __exports__)) {
    api.reload('41bba789', __exports__)
  }
  
  module.hot.accept("./Sheet.vue?vue&type=template&id=41bba789&ts=true", () => {
    api.rerender('41bba789', render)
  })

}


export default __exports__